export const UPDATE_PASSWORD = "UPDATE_PASSWORD"
export const UPDATE_PASSWORD_SUCCESSFUL = "UPDATE_PASSWORD_SUCCESSFUL"
export const UPDATE_PASSWORD_FAILED = "UPDATE_PASSWORD_FAILED"